import React from 'react';
import { TextField, IconButton, LinearProgress } from '@mui/material';
import { AttachFile as AttachFileIcon } from '@mui/icons-material';
import { DatePicker, MobileTimePicker } from '@mui/x-date-pickers';

import DialogWrapper from '../../../../common/components/DialogWrapper/DialogWrapper';

const filterSpacingStyle = { width: '20%', marginRight: '2rem' };

const EditLog = (props) => (
  <DialogWrapper
    open={props.open}
    title={props.title}
    onClickMainAction={props.onClickMainAction}
    onClickCancel={props.onClickCancel}
    disableMainAction={props.disableMainAction}
  >
    <div>
      <DatePicker
        slotProps={{
          textField: () => ({
            'data-qa': 'qa-date-logDate',
          }),
          actionBar: {
            // The actions will be the same between desktop and mobile
            actions: ['cancel', 'accept'],
          },
        }}
        className="u-mt-half u-mr-half"
        closeOnSelect={false}
        style={filterSpacingStyle}
        label="Date"
        placeholder="Action date"
        value={props.logBooklog.LogBookTimeStamp}
        disableFuture
        onAccept={(dateTime) => props.handleChangeFor('LogBookTimeStamp', dateTime)}
        format={'YYYY-MM-DD'}
      />
      <MobileTimePicker
        slotProps={{
          textField: () => ({
            'data-qa': 'qa-date-logTime',
          }),
        }}
        className="u-mt-half u-mr-half"
        closeOnSelect={false}
        style={filterSpacingStyle}
        label="Time"
        value={props.logBooklog.LogBookTimeStamp}
        onAccept={(dateTime) => props.handleChangeFor('LogBookTimeStamp', dateTime)}
        ampm={false}
      />
    </div>
    <div>
      <TextField
        data-qa="qa-activityInput"
        label="Action"
        placeholder="Enter the performed action"
        value={props.logBooklog.Action}
        onChange={(e) => props.handleChangeFor('Action', e.target.value)}
        margin="normal"
        fullWidth
        multiline
        rowsMax={10}
      />
    </div>
    <div className="u-mb-full">
      <div className="u-mb-full">
        <TextField
          data-qa="qa-fileinputLogbook"
          label="Attachement file path"
          placeholder="Select a file by clicking the attach button."
          style={{ width: '80%' }}
          value={props.logBooklog.FileName}
        />

        <input
          data-qa="qa-fileUploadInput"
          id="browseInput"
          type="file"
          style={{ display: 'none' }}
          ref={(input) => {
            props.logBooklog.FileInput = input;
          }}
          onChange={props.onClickFileBrowse}
        />
        <label htmlFor="browseInput">
          <IconButton
            variant="raised"
            data-qa="qa-browseFileButton"
            color="primary"
            component="span"
          >
            <AttachFileIcon />
          </IconButton>
        </label>
      </div>
      <div className="u-pt-full">
        <LinearProgress
          data-qa="qa-uploadProgressBar"
          variant="determinate"
          value={props.logBooklog.UploadCompleted}
        />
      </div>
    </div>
  </DialogWrapper>
);

export default EditLog;
